/* eslint-disable react-hooks/exhaustive-deps */
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Grid } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'redux/store'
import StudentCard from './studentCard'
import BenchmarkPerformanceChart from '../benchmarks/BenchmarkPerformanceChart'
import MainTable from 'components/organisms/tables/MainTable'
import MainTableFiltersForm from 'components/organisms/forms/tableFilters/MainTableFiltersForm'
import { useTableModel } from 'utils/tableModels/useBenchmarkEvaluationsTableModel'
import { benchmarkEvaluationsAPI, useGET_benchmarkEvaluationsQuery } from 'redux/api/benchmarkEvaluationsApi'
import { clearAllFilters, setSearch } from 'redux/ui/benchmarkEvaluationsUI'
import formModel, { initialValues } from 'utils/tableFilterModels/benchmarksTableFilterModel'
import ExtraFilters from 'components/organisms/forms/tableFilters/kpiEvaluations/ExtraFilters'
import { useGET_learningStyleQuestionsQuery } from 'redux/api/studentsApi'
import DialogPopup from 'components/molecules/DialogPopup'
import { setBenchmark } from 'redux/ui/benchmarksUI'
import BenchmarkStudent from '../benchmarks/BenchmarkStudent'


interface IProps {
  student: any
  tabText?: string
  tabKey?: string
}

const StudentBenchmarkTracker: FC<IProps> = ({student}) => {

  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const reduxKey = 'benchmarkEvaluations'


  const activeFilters = useSelector((state: RootState) => state[reduxKey].activeFilters)

  const filters = {
    search: useSelector((state: RootState) => state[reduxKey].tableFilters.search),
    grade_level: useSelector((state: RootState) => state[reduxKey].tableFilters.grade_level),
    subject: useSelector((state: RootState) => state[reduxKey].tableFilters.subject),
    domain: useSelector((state: RootState) => state[reduxKey].tableFilters.domain),
    cluster: useSelector((state: RootState) => state[reduxKey].tableFilters.cluster),
    group: useSelector((state: RootState) => state[reduxKey].tableFilters.group),
    student: student.student_profile_id,
    created_at_after: useSelector((state: RootState) => state[reduxKey].tableFilters.created_after),
    created_at_before: useSelector((state: RootState) => state[reduxKey].tableFilters.created_before),
  }
  
  const {
    data: learningStyle,
  } = useGET_learningStyleQuestionsQuery(student.student_profile_id, {skip: !student})
      
  const benchmark = useSelector((state: RootState) => state['benchmarks'].benchmark)
  const benchmarkStudent = student.student_profile_id

  return (
    <>
  
      <MainTable
        useTableModel={useTableModel}
        getTableData={useGET_benchmarkEvaluationsQuery}
        filters={filters}
        header={
          <>
            <MainTableFiltersForm
              reduxKey={reduxKey}
              tag="benchmark-evaluations"
              entityName={t('common.benchmark-tracker')}
              addLabel={t('common.add-benchmark')}
              api={benchmarkEvaluationsAPI}
              setSearch={setSearch}
              clearAllFilters={clearAllFilters}
              formModel={formModel}
              initialValues={initialValues}
              activeFilters={activeFilters}
              openFilters
              hideDefaultActions
              >
              <ExtraFilters hideStudentFields />
            </MainTableFiltersForm>

              <Box mt={1} mb={3}>
               <Grid container rowSpacing={3} columnSpacing={3}>
                 <Grid item xs={12} md={4}>
                   <StudentCard student={student} learningStyle={learningStyle} step={1}/>
                 </Grid>
                 <Grid item xs={12} md={8}>
                   <BenchmarkPerformanceChart filters={filters}/>
                 </Grid>
               </Grid>
              </Box>  

          </>
        }
        />

        {benchmarkStudent && benchmark && <DialogPopup
            title={t('common.benchmark-tracker')}
            onClose={() => {
              dispatch(setBenchmark(null))
            }}
            open
            popupWidth={'1400px'}
            popupPadding={0}
          >
            <BenchmarkStudent student={benchmarkStudent} benchmark={benchmark} />
        </DialogPopup>}

    </>
  )
}

export default StudentBenchmarkTracker
